import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ScrollSpy from "react-ui-scrollspy";
import GotoTop from "../common/GotoTop";
import ContactCTA from "../contact/contactCTA";
import CloudMgmtBanner from "./CloudMgmtBanner";
import CloudMgmtBenefits from "./CloudMgmtBenefits";
import CloudMgmtFaq from "./CloudMgmtFaq";
import CloudMgmtInfo from "./CloudMgmtInfo";
import CloudMgmtService from "./CloudMgmtService";

const CloudMgmtHome = () => {
  return (
    <div>
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Flint Infotech - Cloud Management & IT Consulting Services
          </title>
          <meta
            name="description"
            content="Flint Infotech provides efficient Cloud Management Services, offering seamless operations, cost savings, and enhanced security. We specialize in managed cloud services, cloud computing, and cybersecurity solutions."
          />
          <link rel="canonical" href="https://flintinfotech.com/" />

          <meta
            property="og:title"
            content="Flint Infotech - Cloud Management & IT Consulting Services"
          />
          <meta
            property="og:description"
            content="Flint Infotech provides efficient Cloud Management Services, offering seamless operations, cost savings, and enhanced security. We specialize in managed cloud services, cloud computing, and cybersecurity solutions."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://flintinfotech.com/" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Flint Infotech - Cloud Management & IT Consulting Services"
          />
          <meta
            name="twitter:description"
            content="Flint Infotech provides efficient Cloud Management Services, offering seamless operations, cost savings, and enhanced security. We specialize in managed cloud services, cloud computing, and cybersecurity solutions."
          />

          <meta name="robots" content="index, follow" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
      </HelmetProvider>

      <CloudMgmtBanner />
      <ScrollSpy>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <CloudMgmtInfo />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <CloudMgmtService />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <CloudMgmtBenefits />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <CloudMgmtFaq />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <ContactCTA />
        </AnimationOnScroll>
      </ScrollSpy>
      <GotoTop />
    </div>
  );
};

export default CloudMgmtHome;
